import { render, staticRenderFns } from "./listOrders.vue?vue&type=template&id=528b7e36"
import script from "./listOrders.vue?vue&type=script&lang=js"
export * from "./listOrders.vue?vue&type=script&lang=js"
import style0 from "./listOrders.vue?vue&type=style&index=0&id=528b7e36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports